import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { unicodeToString } from "../../../../Js/Common";
import { initAudioReset } from "../../../../Js/ILTActions";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import PauseIcon from "@mui/icons-material/Pause";

const pathToParentMenu = ["root"];

const WwInstruction = (props) => {
  let { audioStatus, initAudio, audioStatusInit } = useSelector(
    (state) => state.currentILTActions
  );

  let [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
    console.log("initHide",props.initHide,",,,",props.data.myId);
  }, [props.initHide]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                backgroundColor: "#3eda00ff",
              }}
            >
              <Grid item xs={10}>
                <Box
                  sx={{
                    padding: 2,
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                  }}
                >
                  <Typography
                    color="#5f5600ff"
                    sx={{
                      fontWeight: "bold",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.5rem",
                      },
                    }}
                  >
                    <div
                      className={classnames}
                      id={props.data.myId.self}
                      dangerouslySetInnerHTML={{
                        __html: unicodeToString(props.data.source),
                      }}
                      style={{ display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block', color: "#5f5600ff" }}
                    ></div>
                  </Typography>
                </Box>
              </Grid>
              {initAudio && (
                <Grid item xs={2} sx={{ textAlign: "center", pr: 2,mt: 1.1 }}>
                  <IconButton
                    sx={{
                      color: "#FFFFFF",
                      backgroundColor: "#5f5600ff",
                      border: "1px solid #DB8829",
                      mx: 0,
                      padding: 0,
                     
                    }}
                    onClick={() => {
                      initAudioReset(true);
                    }}
                  >
                    {audioStatusInit && (
                      <PauseIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                    {!audioStatusInit && (
                      <MusicNoteIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WwInstruction;
